import { Card, Grid, Typography } from "@mui/material";
import React, { useMemo } from "react";
import CardBody from "../../../components/Card/CardBody";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import { taggables } from "../../../variables/app";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormFile from "../../../components/Forms/FormFile";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { ImageResolutionHint } from "../../../components/ImageHints/ImageResolutionHint";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Algemeen() {
  const taggableOptions = useMemo(() => convertArrayToSelectOptions(taggables), []);
  const tagTypeOptions = useMemo(
    () =>
      convertArrayToSelectOptions([
        { label: "Allergen", value: "ALLERGEN" },
        { label: "Preference", value: "PREFERENCE" },
        { label: "Brand", value: "BRAND" },
      ]),
    []
  );

  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <FormSwitchTC name={"active"} tDefault={"Tag active"} tKey={"tags.form.algemeen.label.active"} />

          <FormSelectTC name={"tag_type"} options={tagTypeOptions} tDefault={"Tag type"} tKey={"tags.tag_type"} />

          <FormSwitchTC
            defaultValue={true}
            name={"show_tag"}
            tDefault={"Show tag"}
            tKey={"tags.form.algemeen.label.show_tag"}
          />
          <FormSelectTC
            name={"tagType"}
            options={taggableOptions}
            tDefault={"Tag type"}
            tKey={"tags.form.algemeen.label.tagType"}
          />

          <FormTextTC name={"tagName"} tDefault={"Tag name"} tKey={"tags.form.algemeen.label.tagName"} />

          <Card sx={{ maxWidth: 600, p: 2, width: 1 }}>
            <Typography>
              <TranslationWrapper tDefault={"Tag image"} tKey={"Tag.image"} />
            </Typography>
            <ImageResolutionHint res={"100x100"} />
            <FormFile canCrop={true} name={"imgid"} nullable={true} type={"image"} />
          </Card>
        </Grid>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
